import React, { useRef } from "react";
import "./textfield.css";

const TextfieldNumberSPF = ({ placeholder, functionSetValeurs, index }) => {
  const ref = useRef(null);

  const formatFr = (n) =>
    new Intl.NumberFormat("fr-FR").format(Number(n || 0));

  const parseFr = (s) => {
    const cleaned = String(s || "")
      .replace(/\s/g, "")   // retire les espaces
      .replace(",", ".");   // virgule -> point
    const n = parseFloat(cleaned);
    return Number.isNaN(n) ? 0 : n;
  };

  return (
    <input
      type="text"
      inputMode="decimal"
      className="input_field"
      defaultValue="0"
      ref={ref}
      placeholder={placeholder}
      onChange={(e) => {
        let raw = e.target.value;
        let numeric = parseFr(raw);

        // bloquer les valeurs négatives
        if (numeric < 0) {
          numeric = 0;
        }

        // affichage en FR permanent
        e.target.value = formatFr(numeric);

        // envoi au parent (toujours un number positif)
        functionSetValeurs(index, numeric);
      }}
      onBlur={(e) => {
        let numeric = parseFr(e.target.value);
        if (numeric < 0) numeric = 0;
        e.target.value = formatFr(numeric);
      }}
    />
  );
};

export default TextfieldNumberSPF;